import styled from "styled-components";

export const StyledTableDentroDoCard = styled.section`
width: 100%;
table, thead > tr > th, th {
    font-size: 11px !important;
}

th {
    font-size: 12px !important;
    color: #a09696;
}

.table thead th {
    border-bottom: none;
}

.table-legend-info {
    font-size: 12px;
    text-align: center;
    font-weight: 1000;
}

.hover {
    &:hover {
        cursor: pointer;
    }
}

.ellipse-height {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.border-none {
    border: none;
}

.table-data-info {
    font-size: 12px;
    text-align: center;
}

.table-data-info-warning {
    font-size: 12px;
    text-align: center;
    background-color: #fff3cd;
}

.table-data-info-canceled {
    font-size: 12px;
    text-align: center;
    // background-color: #FF7F7F;
}

.table-data-info-pro-bono {
    font-size: 12px;
    text-align: center;
    background: #cdeeff;
}

.table-width {
    width: 100%;
}

table.table-bordered{
    border:1px solid #E8E8E8;
    margin-top:20px;
    border-top-style: none;
    border-left-style: none;
    border-right-style: none;
  }
table.table-bordered > thead > tr > th{
    border:1px solid #E8E8E8;
    border-top-style: none;
    border-left-style: none;
    border-right-style: none;
}
table.table-bordered > tbody > tr > td{
    border:1px solid #E8E8E8;
    border-top-style: none;
    border-left-style: none;
    border-right-style: none;
}

.table-value {
    font-size: 12px;
    text-align: center;
    font-weight: 1000;
}

.table-nowrap {
    white-space: nowrap;
}


.table-button {
    font-size: 14px;
    text-align: center;
    font-weight: 1000;
    width: 30% !important;
    color: #E8E8E8;
}

.table-color-button {
    color: #EE4B21;
}

.size-icon-acoes {
    font-size: 16px;
    cursor: pointer;
}

thead > tr > th{
    font-size: 13px;
}

.table-scroll {
    overflow-y: hidden;
    width:100%;
    height:100%;
}

.primeiro-ativo {
    color: #6c757d;
    font-weight: bold;
}

.primeiro-ativo-wip {
    color: #5c6064;
    font-weight: bold;
}

.primeiro-reprovado {
    background: #ff626230;
}

@media only screen and (max-width: 769px) {
    .table-scroll {
        overflow-x: scroll;
    }

    .form-container-min {
        width: 100% !important;
    }


}
input {
    padding: 0.5rem 0.3rem;
    border-radius: 0.25rem;
    border: solid 1px #D2D2D2;
    width: -webkit-fill-available;
}

@media only screen and (min-width: 770px) {
    .table-scroll {
        overflow-y: scroll;
        overflow-x: hidden !important;
    }

        .table-container {
            width: 100%;
            overflow-y: auto;
            overflow-x: hidden;
            height: 550px;


            table {
                border-collapse: collapse;
                width: auto;
                table-layout: auto;
            }

            th,
            td {
            }

            th {
                background-color: #fff;
                position: sticky;
                top: 0;
            }
          }

}


@media only screen and (min-width: 1500px) {

    .fixed-width-200 {
        width: 200px !important;
        white-space: wrap;
    }


    .fixed-width-390 {
        width: 390px !important;
        white-space: wrap;
    }



    .fixed-width-180 {
        width: 180px !important;
        white-space: wrap;
    }



}
.fixed-width-95 {
    width: 95px !important;
    white-space: nowrap !important;
}


`;
